import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Settings from "./Settings";

export default function Counter() {
  const progressBar = document.querySelector(".current-progress");
  const preparation = useSelector((state) => state.preparation);
  const exercices = useSelector((state) => state.exercices);
  const currentExercice = useSelector((state) => state.currentExercice);
  const interval = useSelector((state) => state.interval);
  const currentInterval = useSelector((state) => state.currentInterval);
  const active = useSelector((state) => state.active);
  const currentActive = useSelector((state) => state.currentActive);
  const passive = useSelector((state) => state.passive);
  const currentPassive = useSelector((state) => state.currentPassive);
  const pause = useSelector((state) => state.pause);
  const currentPause = useSelector((state) => state.currentPause);
  const lap = useSelector((state) => state.lap);
  const end = useSelector((state) => state.end);
  const currentLap = useSelector((state) => state.currentLap);
  const preparationActive = useSelector((state) => state.preparationActive);
  const workActive = useSelector((state) => state.workActive);
  const restActive = useSelector((state) => state.restActive);
  const pauseActive = useSelector((state) => state.pauseActive);

  const [play, setPlay] = useState(false);

  const dispatch = useDispatch();

  ////////////////////////// end

  useEffect(() => {
    if (end) {
      resetTimer();
    }
  }, [end]);

  //////////////////////// reset
  const resetTimer = () => {
    const progressBar = document.querySelector(".current-progress");
    progressBar.style.width = `100%`;
    setPlay(false);
    progressBar.style.background = "linear-gradient( 220deg,#b3efb2, #7a9e7e )";

    dispatch({
      type: "RESET",
    });
  };

  //////////////////////// active timer

  const activeTimer = () => {
    setPlay(!play);
  };

  useEffect(() => {
    let id;
    if (play) {
      id = window.setInterval(() => {
        dispatch({
          type: "ACTIVE-TIMER",
        });
      }, 1000);
    }

    return () => {
      window.clearInterval(id);
    };
  }, [play]);

  ////////////////////////// progress bar
  useEffect(() => {
    if (play) {
      if (workActive) {
        progressBar.style.width = `${(currentActive * 100) / active}%`;
        progressBar.style.background =
          "linear-gradient( 220deg,#b3efb2, #7a9e7e )";
      } else if (restActive) {
        progressBar.style.width = `${(currentPassive * 100) / passive}%`;
        progressBar.style.background =
          "linear-gradient( 220deg,#7a9e7e ,#31493c )";
      } else if (pauseActive) {
        progressBar.style.width = `${(currentPause * 100) / pause}%`;

        progressBar.style.background =
          "linear-gradient( 220deg, #70210B, #240902)";
      }
    }
  }, [currentActive, currentPassive, currentPause]);

  return (
    <div className="container-counter">
      <Settings res={resetTimer} />
      <div className="exercice">
        {end
          ? ""
          : preparationActive && !end
          ? "Début de la séance"
          : `${exercices[currentExercice]}`}
      </div>

      {pauseActive === true ? (
        <div className="timers">
          <div className="primary">
            <em>{currentPause}</em>/{pause}s
          </div>
        </div>
      ) : preparationActive && !play && !end ? (
        <div className="timers"></div>
      ) : preparationActive && play ? (
        <div className="timers">
          <div className="primary">
            <em>{preparation}</em>
          </div>
        </div>
      ) : end === false ? (
        <div className="timers">
          <div className={workActive ? "primary" : "timer"}>
            <em>{currentActive}</em>/{active}s
          </div>

          <div className={restActive ? "primary" : "timer"}>
            <em>{currentPassive}</em>/{passive}s
          </div>
        </div>
      ) : end === true ? (
        <div className="timers">
          <div className="primary">Séance terminé !</div>
        </div>
      ) : (
        ""
      )}

      <div className="laps">
        <div className="current-interval info">
          <div>intervalle : </div>
          <div>
            <em>{currentInterval}</em> / {interval}
          </div>
        </div>
        <div className="message info">
          {!play
            ? "PAUSE"
            : preparationActive
            ? "PREPARATION"
            : workActive
            ? "GO !"
            : restActive
            ? "REPOS"
            : pauseActive
            ? "FIN DU TOUR"
            : ""}
        </div>
        <div className="current-lap info">
          <div>tour : </div>{" "}
          <div>
            <em> {currentLap}</em> / {lap}
          </div>
        </div>
      </div>
      <div className="progress-bar">
        <div className="current-progress"></div>
      </div>
      <div className="buttons">
        <button onClick={activeTimer}>
          {play ? (
            <i className="fas fa-pause"></i>
          ) : (
            <i className="fas fa-play"></i>
          )}
        </button>
        <button onClick={resetTimer}>
          <i className="fas fa-redo-alt"></i>
        </button>
      </div>
    </div>
  );
}
